import {
  Button,
  Divider,
  Flex,
  Heading,
  Link,
  SimpleGrid,
  Text,
  useToast,
} from '@chakra-ui/react';
import firebase from 'firebase';
import React, { useState } from 'react';
import Lottie from 'react-lottie';
import animationData from '../../../assets/animations/clock.json';
import { PageContainer } from '../../../components/container/PageContainer';
import { useConfig } from '../../../hooks/useConfig';
import { FirebaseUser } from '../../../types/types';

interface TrialEndedProps {
  currentUser: firebase.User;
  userData: FirebaseUser;
}

export const TrialEnded: React.FC<TrialEndedProps> = ({
  currentUser,
  userData,
}) => {
  const [loading, setIsLoading] = useState(false);
  const toast = useToast();
  const firebaseConfig = useConfig();

  const getOnlineVoucher = async () => {
    setIsLoading(true);
    await firebase.firestore().collection('users').doc(currentUser.uid).update({
      isVoucher: true,
    });
    setIsLoading(false);
    toast({
      title: 'Gutschein aktiviert',
      description:
        'Vielen Dank. Ein Kundenberater wird sich in Kürze bei dir melden.',
      status: 'success',
      duration: 9000,
      isClosable: true,
    });
  };

  return (
    <PageContainer isHeader>
      <SimpleGrid columns={[1, 1, 2]} gap={8} alignItems="center">
        <Lottie
          style={{ padding: '10%' }}
          isClickToPauseDisabled={true}
          options={{
            loop: false,
            autoplay: true,
            animationData,
            rendererSettings: {
              preserveAspectRatio: 'xMidYMid meet',
            },
          }}
        />
        <Flex direction="column" mt={[6, 0, 0]}>
          <Heading w="full" mb={3} size="md">
            Hat dir unser Online-Fitness gefallen?
          </Heading>
          <Text mb={3}>
            Wir würden dich gerne persönlich kennen lernen. Bei{' '}
            {firebaseConfig?.displayName} steht der Kunde im Mittelpunkt. Viele
            von unseren Kunden lernen den Sport neu kennen, nachdem sie bei uns
            einmal angefangen haben zu trainieren. Wenn dir unser Online-Fitness
            gefällt, wirst du das richtige Training lieben!{' '}
          </Text>
          <Text mb={3}>
            Selbstverständlich kannst du nach unserem Gespräch weiterhin online
            trainieren.{' '}
          </Text>
          <Divider mb={3} />
          {firebaseConfig && firebaseConfig.onlineMembershipFee > 0 && (
            <Text mb={3}>
              Es besteht die Möglichkeit einer Online-Mitgliedschaft, welche du
              für{' '}
              <Link
                fontWeight="bold"
                target="_blank"
                href={firebaseConfig.onlineMembershipLink}
              >
                {firebaseConfig.onlineMembershipFee}€ pro Monat kaufen
              </Link>{' '}
              kannst.
            </Text>
          )}
          {firebaseConfig && firebaseConfig.thankYouVoucher > 0 && (
            <>
              <Text mb={3}>
                Als kleines Dankeschön für dein Interesse an unserem
                Online-Fitness, wollen wir dir einen VIP-Gutschein im Wert von{' '}
                {firebaseConfig.thankYouVoucher}€ schenken. Klicke einfach auf
                den folgenden Button um diesen zu aktivieren.
              </Text>
              <Button
                disabled={userData.isVoucher}
                isLoading={loading}
                onClick={getOnlineVoucher}
              >
                {userData.isVoucher
                  ? 'Gutschein aktiviert'
                  : 'Ich will den Gutschein!'}
              </Button>
            </>
          )}
        </Flex>
      </SimpleGrid>
    </PageContainer>
  );
};
